import React from "react";
import { Button } from "@dpdgroupuk/mydpd-ui";
import PropTypes from "prop-types";
import { trackProps, withTrack, withTrackProps } from "@dpdgroupuk/react-event-tracker";
import { withProps } from "recompose";
import { compose } from "redux";
import { withRouter } from "react-router";
import styles from "./EmailSent.module.scss";
import { ConfirmIcon } from "../../../../components/Icon";
import { ROUTE, ANALYTICS } from "../../../../constants";

const EmailSent = ({
  onDone
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.container
}, /*#__PURE__*/React.createElement(ConfirmIcon, null), /*#__PURE__*/React.createElement("h1", {
  className: styles.heading
}, "Request submitted"), /*#__PURE__*/React.createElement("p", null, "If your account is valid, and no restrictions are set against it by your admin,", /*#__PURE__*/React.createElement("br", null), "we will send an email to your registered email address with instructions on how to reset your password"), /*#__PURE__*/React.createElement(Button, {
  id: "submitBtn",
  type: "submit",
  variant: "primary",
  className: styles.button,
  onClick: onDone
}, "Done"));

EmailSent.propTypes = {
  onDone: PropTypes.func
};
export default compose(withRouter, withProps(props => ({
  onDone: () => props.history.push(ROUTE.LOGON_PAGE)
})), withTrack(trackProps(ANALYTICS.EMAIL_SENT_PAGE)), withTrackProps({
  onDone: ANALYTICS.EMAIL_SENT_PAGE.ON_DONE
}))(EmailSent);